module.exports = "https://cdn2-fs.clearscore.com/flux/images/92ef103ab5420702e2ac2bea709135f7.jpg";